import {
  GapEnum,
  Stack,
} from '@delmonicos/shared-design-system-react/src/components/stack/stack';

import { useFilters } from '@app/feature/statistics/context/filters.context';
import { EmissionsAvoidedCard } from '@app/feature/statistics/environment-section/cards/emissions-avoided.card';
import { EnvironmentalDataCard } from '@app/feature/statistics/environment-section/cards/environmental-data.card';
import { useCpmsBoGetEcologicalImpactQuery } from '@service/cpms-bo-transaction-reports-ecology-statistics.service';

export const EnvironmentSectionComponent = (): React.JSX.Element => {
  const { transformedFilters } = useFilters();

  const { data } = useCpmsBoGetEcologicalImpactQuery({
    ...transformedFilters,
  });

  return (
    <Stack gap={GapEnum.XL} justifyContent="space-between">
      <EnvironmentalDataCard data={data} />
      <EmissionsAvoidedCard data={data} />
    </Stack>
  );
};
